<template>
  <v-list-item
    class="contact-list-item-v2"
    :class="{ 'active-item': isActive }"
    @click.stop.prevent="$emit('click', $event)"
  >
    <v-list-item-action class="avatar">
      <div
        @mouseenter="openContactCard($event, contact)"
        @mouseleave="closeContactCard"
        @click.stop="openContactCard($event, contact)"
      >
        <SmsAvatar :contact="contact" :size="28" />
      </div>
    </v-list-item-action>

    <v-list-item-content class="content">
      <v-list-item-title class="title">{{ contact.displayName }}</v-list-item-title>
      <v-list-item-subtitle class="sub-title">
        <v-icon size="14">{{ contact.displayIcon }}</v-icon>
        {{ contact.number }}
      </v-list-item-subtitle>
    </v-list-item-content>

    <v-list-item-action>
      <slot name="actions"></slot>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { mapGetters } from 'vuex';
import SmsAvatar from '@/components/SmsAvatar/SmsAvatar';

export default {
  name: 'SmsContactListItemV2',

  components: { SmsAvatar },

  mixins: [ ],

  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      }
    },
    hideContactCard: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { };
  },

  computed: {
    ...mapGetters('conversationsV2', ['activeConversationId']),

    isActive() {
      return this.activeConversationId === this.contact.number;
    }
  },

  created() { },

  beforeDestroy() { },

  methods: {
    openContactCard(event, contact) {
      if (this.hideContactCard) return;

      this.$root.$emit('open-contact-card', {
        contact,
        x: event.target.getBoundingClientRect().right,
        y: event.target.getBoundingClientRect().top
      });
    },
    closeContactCard() {
      this.$root.$emit('close-contact-card');
    }
  }
};
</script>

<style src="./scoped.scss" lang="scss" scoped />
